import { CleanKwhs } from './clean-kwh.typings';

export const sortCleanKwhs = (cleanKwhs: CleanKwhs): CleanKwhs =>
  cleanKwhs.slice().sort((a, b) => {
    const aDate = new Date(a.startDate);
    const bDate = new Date(b.startDate);
    return aDate.getTime() - bDate.getTime();
  });
